/**
 * Villy Designs theme glue (plain script, no dependencies).
 *
 *  1. window.VillyTheme.addToCart(variantId, qty) / addLines([...])  adds to the Shopify basket with /cart/add.js and refreshes
 *     Dawn's cart drawer (or notification) the same way Dawn's own product form does.
 *  2. Intercepts `villy:add-to-cart` (the room builder's "Add all to basket") so every piece goes in with ONE request.
 *  3. Department page: the "Sort" select submits its form, the "Size" select filters the cards on the page (small / medium / large).
 *
 * The 3D elements themselves live in villy-3d.js (a module that loads three.js only when a 3D element nears the viewport).
 */
(function () {
  'use strict';

  var count = null;

  function cartElement() {
    return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
  }

  function routeUrl(name, fallback) {
    return (window.routes && window.routes[name]) || fallback;
  }

  function message(text) {
    var el = document.querySelector('.v-toast');
    if (!el) {
      el = document.createElement('div');
      el.className = 'v-toast';
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      document.body.appendChild(el);
    }
    el.textContent = text;
    el.classList.add('is-on');
    clearTimeout(el._villyTimer);
    el._villyTimer = setTimeout(function () { el.classList.remove('is-on'); }, 3600);
  }

  /** lines: [{ id: variantId, quantity: n }] */
  function addLines(lines) {
    var items = lines
      .map(function (l) { return { id: Number(l.id), quantity: Math.max(1, parseInt(l.quantity, 10) || 1) }; })
      .filter(function (l) { return l.id > 0; });
    if (!items.length) return Promise.reject(new Error('Nothing to add'));

    var cart = cartElement();
    var body = { items: items };
    if (cart && typeof cart.getSectionsToRender === 'function') {
      body.sections = cart.getSectionsToRender().map(function (s) { return s.id; }).join(',');
      body.sections_url = window.location.pathname;
    }

    return fetch(routeUrl('cart_add_url', '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body),
    })
      .then(function (res) { return res.json().then(function (data) { return { ok: res.ok, data: data }; }); })
      .then(function (r) {
        if (!r.ok || r.data.status) {
          throw new Error(r.data.description || r.data.message || 'Could not add to the basket');
        }
        var added = items.reduce(function (n, l) { return n + l.quantity; }, 0);
        count = (count === null ? currentCount() : count) + added;
        if (cart && typeof cart.renderContents === 'function' && r.data.sections) {
          // Dawn's drawer repaints itself, updates the basket bubble and opens
          cart.renderContents(r.data);
          if (cart.classList) cart.classList.remove('is-empty'); // Dawn's product form does this; this path did not
        } else {
          refreshBubble();
          message('Added to your basket.');
        }
        document.dispatchEvent(new CustomEvent('villy:cart-updated', { detail: { count: count } }));
        return r.data;
      });
  }

  function currentCount() {
    var bubble = document.querySelector('.cart-count-bubble span[aria-hidden]');
    var n = bubble ? parseInt(bubble.textContent, 10) : 0;
    return isNaN(n) ? 0 : n;
  }

  function refreshBubble() {
    var target = document.getElementById('cart-icon-bubble');
    if (!target) return;
    fetch(window.location.pathname + '?sections=cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        var doc = new DOMParser().parseFromString(sections['cart-icon-bubble'] || '', 'text/html');
        var fresh = doc.querySelector('.shopify-section');
        if (fresh) target.innerHTML = fresh.innerHTML;
      })
      .catch(function () { /* the basket still works */ });
  }

  window.VillyTheme = {
    addLines: addLines,
    addToCart: function (variantId, qty) { return addLines([{ id: variantId, quantity: qty || 1 }]); },
    count: function () { return count === null ? currentCount() : count; },
  };

  /* "Add all to basket" in Design Your Space: one request for the whole room */
  document.addEventListener('villy:add-to-cart', function (event) {
    var detail = event.detail || {};
    var items = (detail.items || []).filter(function (i) { return i.variantId && i.available !== false; });
    if (!items.length) return; // let the library show its own message
    event.preventDefault();
    addLines(items.map(function (i) { return { id: i.variantId, quantity: i.qty || 1 }; })).catch(function (error) {
      message(error && error.message ? error.message : 'Sorry, something went wrong adding those. Please try again.');
    });
  });

  /* department page controls */
  function initCollection(grid) {
    var toolbar = document.querySelector('.v-toolbar');
    if (!toolbar) return;

    var sort = toolbar.querySelector('[data-villy-sort]');
    if (sort) {
      sort.addEventListener('change', function () {
        var form = sort.closest('form');
        if (form) form.submit();
      });
    }

    var wrap = toolbar.querySelector('[data-villy-size-filter]');
    var select = toolbar.querySelector('[data-villy-size]');
    if (!wrap || !select) return;

    var cards = Array.prototype.slice.call(grid.children);
    var present = {};
    cards.forEach(function (c) { if (c.dataset.size) present[c.dataset.size] = true; });
    var buckets = Object.keys(present);
    if (buckets.length < 2) return; // nothing to choose between
    Array.prototype.forEach.call(select.options, function (o) {
      if (o.value !== 'all' && !present[o.value]) o.remove();
    });
    wrap.hidden = false;

    var countEl = toolbar.querySelector('[data-villy-count]');
    var empty = document.querySelector('[data-villy-empty]');
    var total = cards.length;

    function apply() {
      var want = select.value;
      var shown = 0;
      cards.forEach(function (c) {
        var ok = want === 'all' || c.dataset.size === want;
        c.hidden = !ok;
        if (ok) shown += 1;
      });
      if (countEl) {
        countEl.textContent = shown + ' ' + (shown === 1 ? countEl.dataset.one : countEl.dataset.many);
      }
      if (empty) empty.hidden = shown !== 0;
      grid.hidden = shown === 0 && total > 0;
    }
    select.addEventListener('change', apply);
  }

  /* Studio photos on a black plate (the few originals next to the cream cut-outs): when a picture's four corners are black
     its holder gets .is-plate-dark, which villy-theme.css turns into a deliberate dark frame. Best effort and cheap: a
     24 px copy of the picture is sampled; if the browser refuses (no CORS), nothing changes and the photo is shown as it is. */
  var plateCache = {};
  var PLATE_TARGETS = '.v-card__media, .v-gal__slide, .v-gal__thumb, .v-stage-ssr, .v-hero3d__pic, .vs-tile__media, .vs-media, .vs-push, .vs-thumb, .vs-gal__slide';

  function sampleUrl(src) {
    return /[?&]width=\d+/.test(src) ? src.replace(/([?&]width=)\d+/, '$1' + 24) : src;
  }

  function isDarkPlate(src, done) {
    var key = sampleUrl(src);
    if (key in plateCache) { done(plateCache[key]); return; }
    var probe = new Image();
    probe.crossOrigin = 'anonymous';
    probe.onload = function () {
      var dark = false;
      try {
        var c = document.createElement('canvas');
        c.width = c.height = 8;
        var ctx = c.getContext('2d', { willReadFrequently: true });
        ctx.drawImage(probe, 0, 0, 8, 8);
        var corners = [[0, 0], [7, 0], [0, 7], [7, 7]];
        dark = corners.every(function (xy) {
          var d = ctx.getImageData(xy[0], xy[1], 1, 1).data;
          return (0.2126 * d[0] + 0.7152 * d[1] + 0.0722 * d[2]) < 30;
        });
      } catch (e) { dark = false; }
      plateCache[key] = dark;
      done(dark);
    };
    probe.onerror = function () { plateCache[key] = false; done(false); };
    probe.src = key;
  }

  function markPlates(root) {
    var imgs = (root || document).querySelectorAll(
      '.v-card__poster, .v-gal__slide img, .v-gal__thumb img, .v-stage-ssr img, .v-hero3d__pic img, .vs-tile__media img, .vs-media img, .vs-push img, .vs-thumb img, .vs-gal__slide img'
    );
    Array.prototype.forEach.call(imgs, function (img) {
      if (img.dataset.villyPlate) return;
      var src = img.currentSrc || img.getAttribute('src');
      if (!src || src.indexOf('data:') === 0) return;
      img.dataset.villyPlate = '1';
      isDarkPlate(src, function (dark) {
        if (!dark) return;
        var holder = img.closest(PLATE_TARGETS);
        if (holder) holder.classList.add('is-plate-dark');
      });
    });
  }

  var plateTimer = null;
  function schedulePlates() {
    clearTimeout(plateTimer);
    plateTimer = setTimeout(function () { markPlates(document); }, 250);
  }

  function init() {
    var grid = document.querySelector('[data-villy-grid]');
    if (grid) initCollection(grid);
    schedulePlates();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  // the theme editor re-renders sections
  document.addEventListener('shopify:section:load', init);
  // pictures the 3D elements add after the page has loaded (gallery, hero still)
  if (window.MutationObserver) {
    new MutationObserver(schedulePlates).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
